/* 유튜브 프레임을 **방문 기록을 남기지 않고** 불러온다.

   왜 필요한가 — 의장 지적(2026-09-12) 「왜 백버튼을 3번 눌려야 작동하는지 알아봤어?」
   프레임(iframe)이 문서를 다 읽은 뒤에 주소를 받으면, 그 이동이 **부모 창의 방문 기록에 한 칸씩
   쌓인다.** 메인에 유튜브 프레임이 둘이니 1(진짜 이동) + 2(영상) = 세 칸이 되고,
   뒤로 가기를 세 번 눌러야 앞 페이지로 나간다.

   어떻게 막나 — 빈 프레임(about:blank)으로 시작해서, 화면에 들어올 때
   `contentWindow.location.replace(주소)` 로 **갈아끼운다.**
   replace 는 이름 그대로 기록을 「덮어쓰기」라 새 칸을 만들지 않는다. (src 에 넣으면 칸이 생긴다.)

   ⚠ src 속성을 직접 쓰지 않는다. 쓰는 순간 원래대로 돌아간다. */
(function () {
  /* ⛔ 2026-10-17 방식을 바꿨다 — `contentWindow.location.replace` 를 버린다.

     왜: 소서 개선점 10번 「모바일 환경에서 영상 재생 오류」. 화면에 찍힌 것은
     유튜브 **「동영상 플레이어 구성 오류 · 오류 153」** 이었다.
     재어 보니 replace 방식은 **유튜브 요청을 아예 만들지 못했다**(요청 0건).

     앞선 주석의 「src 에 넣으면 기록 칸이 생긴다」는 **이미 떠 있는 프레임의 src 를 바꿀 때**만 맞다.
     **새 프레임을 만들며 src 를 처음부터 박아 넣으면 칸이 생기지 않는다** — 실측으로 확인했다
     (프레임 둘을 넣어도 `history.length` 2 → 2 그대로, 임베드 요청은 2건 정상).

     그래서 빈 프레임을 **통째로 갈아 끼운다**. 뒤로가기 문제도 그대로 막히고 영상도 뜬다. */
  function 불러오기(f) {
    var u = f.getAttribute('data-ue-src');
    if (!u || f.dataset.ueLoaded) return;
    f.dataset.ueLoaded = '1';

    var 새것 = document.createElement('iframe');
    /* 원래 프레임의 속성을 그대로 옮긴다 — 다만 자리표시용 둘은 뺀다 */
    for (var i = 0; i < f.attributes.length; i++) {
      var at = f.attributes[i];
      if (at.name === 'data-ue-src' || at.name === 'src') { continue; }
      새것.setAttribute(at.name, at.value);
    }
    새것.setAttribute('allow', f.getAttribute('allow') || 'autoplay; encrypted-media; picture-in-picture');
    새것.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    새것.setAttribute('loading', 'lazy');
    새것.dataset.ueLoaded = '1';
    새것.src = u;                       /* ⚠ 넣기 **전에** 박는다. 넣은 뒤 바꾸면 기록 칸이 생긴다 */

    if (f.parentNode) { f.parentNode.replaceChild(새것, f); }
  }

  function 붙이기() {
    var 목록 = document.querySelectorAll('iframe.ue-yt:not([data-ue-loaded])');
    if (!목록.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(목록, 불러오기);
      return;
    }
    var 관찰 = new IntersectionObserver(function (들) {
      들.forEach(function (e) {
        if (e.isIntersecting) { 불러오기(e.target); 관찰.unobserve(e.target); }
      });
    }, { rootMargin: '300px' });
    Array.prototype.forEach.call(목록, function (f) { 관찰.observe(f); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', 붙이기);
  } else {
    붙이기();
  }
  /* 테마 편집기에서 구간을 다시 그리면 새 프레임이 생긴다 */
  document.addEventListener('shopify:section:load', 붙이기);
})();
